export default __webpack_public_path__ + "static/charlie-gerard-73a7431e80b084180c24dfde97518018.jpg";